import { render } from "./PublicPage.vue?vue&type=template&id=7780739c&scoped=true"
import script from "./PublicPage.vue?vue&type=script&lang=js"
export * from "./PublicPage.vue?vue&type=script&lang=js"

import "./PublicPage.vue?vue&type=style&index=0&id=7780739c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7780739c"]])

export default __exports__